// src/app/components/navigation/navigation.component.ts
import { Component, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';
import { AppConstants, MenuLink } from "../../constants/app-constants";
import { NavigationEnd, Router } from "@angular/router";
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { UserService } from 'src/app/services/user/user.service';
import { User } from 'src/app/model/User';
import { AuthService } from 'src/app/services/auth/auth.service';
import { SessionService } from 'src/app/services/session/session.service';
import { DialogService } from 'src/app/services/dialog/dialog.service';

@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NavigationComponent {
  /** Available menus to render */
  menus: MenuLink[] = AppConstants.MENU_LINKS.filter(menu => !menu.hideFromNavigation);

  /** The current URL of the application */
  currentUrl: string;

  /** Borrower portal or command center status */
  userRole: "SUPPLIER" | "BORROWER" | null = null;

  // Store the settings URL constant for template checking
  public settingsUrl = AppConstants.MENU_SETTINGS;

  public sidenavExpand: boolean = true;

  @Output() public sidenavToggled = new EventEmitter<boolean>();

  constructor(
    private _router: Router,
    private _iconRegistry: MatIconRegistry,
    private _sanitizer: DomSanitizer,
    private _userService: UserService,
    private _dialogService: DialogService,
    private _authService: AuthService,
    private _sessionService: SessionService,
  ) {
    // Set the initial url
    this.currentUrl = this._router.url.replace('/', '');

    // Subscribe to URL changes
    this._router.events.subscribe(
      (event: any): void => {
        if (event instanceof NavigationEnd) {
          this.currentUrl = event.url.replace('/', '');
        }
      }
    );

    // Register custom SVG icons (unchanged)
    this._iconRegistry.addSvgIcon(
      'nav_collapse',
      this._sanitizer.bypassSecurityTrustResourceUrl('assets/icons/nav-collapse.svg'),
    );
    // ... (other icon registrations)

    // Subscribe to user changes
    this._userService.user$.subscribe(
      (user: User | null) => {
        this.expandSidebar();

        if (user == undefined) return;
        this.userRole = user.companies[0].companyType;
      }
    );
  }

  /**
   * Refresh before navigate to a route link. This is to prevent race conditions between refershing and services fetching data
   */
  public navigateTo(route: string): void {
    // Refresh session before navigation if authenticated
    if (this._authService.authenticated && !this._authService.isRefreshing) {
      this._sessionService.refresh();
    }

    this._router.navigate([route]);
  }

  /**
   * Open the settings modal dialog
   */
  openSettingsModal(): void {
    this._dialogService.openSettingsModal().subscribe();
  }

  /**
   * Toggle the sidebar (existing method)
   */
  toggleSidebar() {
    this.sidenavExpand = !this.sidenavExpand;
    this.sidenavToggled.emit(this.sidenavExpand);
  }

  /**
   * Expand the sidebar
   */
  expandSidebar() {
    this.sidenavExpand = true;
    this.sidenavToggled.emit(this.sidenavExpand);
  }
}
